module.exports = __webpack_public_path__ + "static/media/deck-4-straight.7ddc21fe.png";